module.exports = __webpack_public_path__ + "static/media/worry-free-5.f075cbd5.png";